import React, {useCallback, useState} from "react";
import Emergency from "./emergency";
import PayCard from "./PayCard";
import Brigade from "../brigade/brigade";
import {RightBigPanelFooter} from "../../shared";
import {Button} from "../../ui-components";
import {cancelCustomerOfferBrigadeRequests, sendCustomerSentrySingleRequests} from "../requests/er-thunk";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import PatientInfo from "./PatientInfo"
import PatientDetails from "../scheduledCall/PatientDetails"

const CreatedEmergencyContent = ({request, selectedModalBrigade}) => {

  const {user} = useAppSelector(state => state.user)
  const dispatch = useAppDispatch()
  const handleSubmit = useCallback(() => {
   dispatch(sendCustomerSentrySingleRequests())
  } , [dispatch])

  const handleClose = useCallback(() => {
    dispatch(cancelCustomerOfferBrigadeRequests({item: {request_uuid: request?.uuid, customer_uuid: request?.customer_uuid}
    }))
  } , [dispatch, request?.customer_uuid, request?.uuid])

  return  <>
    <div style={{width: "50%", borderRight: " 1px solid #E7E7E7" }}>
      <Emergency request={request}/>
      <PatientDetails request={request}/>
      <PayCard request={request}/>
    </div>
    <div style={{width: "50%", height: "86vh"}}>
      <PatientInfo/>

      {/*<Brigade selectedModalBrigade={selectedModalBrigade} />*/}
      <RightBigPanelFooter>
        <div style={{display: "flex", gap: 12, width: "100%"}}>
        <Button onClick={handleSubmit} type='contained' fullWidth>Отправить заявку в торги</Button>
        <Button onClick={handleClose} type='outlined' fullWidth>Отказать</Button>
        </div>
      </RightBigPanelFooter>
    </div>

  </>
}

export default CreatedEmergencyContent
